module.exports = __webpack_public_path__ + "static/media/004.8403dc79.jpg";